/* esm.sh - rxjs@7.8.1/dist/esm/internal/operators/scan */
import{operate as n}from"../util/lift.mjs";import{scanInternals as e}from"./scanInternals.mjs";function m(r,t){return n(e(r,t,arguments.length>=2,!0))}export{m as scan};
//# sourceMappingURL=scan.mjs.map